import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export function Label({ className, ...props }: ComponentProps<'label'>) {
  // Generic wrapper — the htmlFor↔control association is the caller's responsibility.
  // eslint-disable-next-line jsx-a11y/label-has-associated-control
  return <label className={cn('text-sm font-medium leading-none', className)} {...props} />;
}
